var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"mb-4"},[_c('nav',{staticClass:"container mx-auto py-2 px-3"},[_c('p',{staticClass:"text-primary-dark font-bold"},[_vm._v("Goals")])])])
}]

export { render, staticRenderFns }